import React from "react";

export default function PremiumPlusCarWash() {
  return (
    <div className="space-y-2 text-sm text-gray-800">
      <p className="font-semibold">Includes:</p>
      <ul className="list-disc text-black-500 ">
          <li>Premium Natural Foam Car Shampoo</li>
          <li>High Pressure Foam Wash</li>
          <li>Interior Cleaning</li>
          <li>High Pressure Vacuum</li>
          <li>Showroom Quality Dashboard & Interior Polish</li>
          <li>Showroom Quality Tyre Polish</li>
          <li>Free Aroma Spray</li>
          <li>Foot Mat</li>
          <li>
            <b>
              CLEANING INSIDE BONNET IS AT OWNER'S RISK. - NOT RECOMMENDED (RS
              100 EXTRA)
            </b>
          </li>
        </ul>
    </div>
  );
}


